const UUID_REGEX = /^[a-z,0-9,-]{36,36}$/;

export const isUUID = (value: string): boolean => UUID_REGEX.test(value);
